import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { CardFooter,Card, CardHeader, CardTitle, CardDescription, CardContent, } from './ui/card';

const ServiceCard = ({ service, onClick }) => {
  const IconComponent = service.icon;

  return (
    <motion.div
      whileHover={{ y: -8 }}
      transition={{ duration: 0.3 }}
      className="h-full"
    >
      <Card className="h-full flex flex-col overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-slate-100 bg-white group">
        <div className={`h-2 w-full bg-gradient-to-r ${service.color}`}></div>
        
        <CardHeader className="pt-6 pb-4">
          <div className="flex justify-between items-start mb-4">
            <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${service.color} flex items-center justify-center shadow-sm transform group-hover:scale-110 transition-transform duration-300`}>
              <IconComponent className="w-7 h-7 text-white" />
            </div>
            <Badge variant="secondary" className="bg-slate-100 text-slate-600 hover:bg-slate-200 font-medium text-xs">
              {service.category}
            </Badge>
          </div>
          <CardTitle className="text-xl font-bold text-slate-800 line-clamp-1">{service.name}</CardTitle>
          <CardDescription className="text-sm text-slate-500 mt-2 line-clamp-2 h-10">
            {service.description}
          </CardDescription>
        </CardHeader>

        <CardContent className="flex-grow pb-2">
          <ul className="space-y-2">
            {service.included.slice(0, 2).map((item, index) => (
              <li key={index} className="flex items-center text-sm text-slate-600">
                <div className={`w-1.5 h-1.5 rounded-full bg-gradient-to-r ${service.color} mr-2 flex-shrink-0`}></div>
                <span className="truncate">{item}</span>
              </li>
            ))}
            {service.included.length > 2 && (
              <li className="text-xs text-slate-400 italic mt-1">
                + {service.included.length - 2} more features
              </li>
            )}
          </ul>
        </CardContent>

        <CardFooter className="pt-4 pb-6 px-6 mt-auto border-t border-slate-50">
          <Button
            onClick={() => onClick(service)}
            variant="ghost"
            className={`w-full justify-between hover:bg-slate-50 text-slate-700 group-hover:text-blue-600 transition-colors`}
          >
            Learn More
            <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" />
          </Button>
        </CardFooter>
      </Card>
    </motion.div>
  );
};

export default ServiceCard;